import { ISgwtSuperHeaderI18N, ISgwtSuperHeaderI18NLanguage } from './sgwt-super-header.types';

const SGWT_SUPER_HEADER_I18N_EN: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'Account center',
  changePassword: 'Change password',
  myServicesLink: 'My services',
  navigateAs: 'Navigate as',
  navigatingAs: 'Navigating as',
  signOut: 'Sign out',
  userProfile: 'Your profile',
  searchPlaceholder: 'Quick search',
  columnName: 'Client name',
  columnCompany: 'Client company',
  fist: 'First',
  previous: 'Previous',
  next: 'Next',
  last: 'Last',
  legendShowing: 'Showing',
  legendTo: 'to',
  legendOf: 'of',
  legendEntries: 'entries'
};

const SGWT_SUPER_HEADER_I18N_FR: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'Mon compte',
  changePassword: 'Changer le mot de passe',
  myServicesLink: 'Mes services',
  navigateAs: 'Naviguer en tant que',
  navigatingAs: 'Naviguer en tant que',
  signOut: 'Se déconnecter',
  userProfile: 'Votre profil',
  searchPlaceholder: 'Recherche rapide',
  columnName: 'Nom du client',
  columnCompany: 'Compagnie du client',
  fist: 'Premier',
  previous: 'Précédent',
  next: 'Suivant',
  last: 'Dernier',
  legendShowing: 'Affichage de',
  legendTo: 'à',
  legendOf: 'sur',
  legendEntries: 'entrées'
};

const SGWT_SUPER_HEADER_I18N_ES: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'Mi cuenta',
  changePassword: 'Cambiar la contraseña',
  myServicesLink: 'Mis servicios',
  navigateAs: 'Inpersonalización',
  navigatingAs: 'Navegar como',
  signOut: 'Desconexión',
  userProfile: 'Su perfil',
  searchPlaceholder: 'Búsqueda rápida',
  columnName: 'Nombre del cliente',
  columnCompany: 'Empresa del cliente',
  fist: 'Primero',
  previous: 'Precedente',
  next: 'Siguiente',
  last: 'Último',
  legendShowing: 'isualización de',
  legendTo: 'en',
  legendOf: 'en',
  legendEntries: 'entradas'
};

const SGWT_SUPER_HEADER_I18N_DE: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'Mein Konto',
  changePassword: 'Passwort ändern',
  myServicesLink: 'Meine Services',
  navigateAs: 'Impersonalisierung',
  navigatingAs: 'Surfen als',
  signOut: 'Abmelden',
  userProfile: 'Ihr Profil',
  searchPlaceholder: 'Suche nach Benutzername',
  columnName: 'Name des Kunden',
  columnCompany: 'Firma des Kunden',
  fist: 'Erster',
  previous: 'Vorheriger',
  next: 'Nächster',
  last: 'Letzter',
  legendShowing: 'Anzeige von',
  legendTo: 'in',
  legendOf: 'auf',
  legendEntries: 'Eingänge'
};

const SGWT_SUPER_HEADER_I18N_ZH: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: '我的账户',
  changePassword: '更改密码',
  myServicesLink: '我的服务',
  navigateAs: '无人称',
  navigatingAs: '浏览',
  signOut: '退出',
  userProfile: '个人档案',
  searchPlaceholder: '以用户名搜索',
  columnName: '客户姓',
  columnCompany: '客户公司',
  fist: '首个',
  previous: '上一个',
  next: '下一步',
  last: '末尾',
  legendShowing: '显示',
  legendTo: '于',
  legendOf: '在',
  legendEntries: '输入信息'
};

const SGWT_SUPER_HEADER_I18N_RU: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'Мой кабинет',
  changePassword: 'Изменить пароль',
  myServicesLink: 'Мои сервисы',
  navigateAs: 'Навигация в качестве',
  navigatingAs: 'Навигация в качестве',
  signOut: 'Выход',
  userProfile: 'Ваш профиль',
  searchPlaceholder: 'Быстрый поиск',
  columnName: 'Имя клиента',
  columnCompany: 'Компания клиента',
  fist: 'Первая',
  previous: 'Предыдущая',
  next: 'Следующая',
  last: 'Последняя',
  legendShowing: 'Показано',
  legendTo: '-',
  legendOf: 'из',
  legendEntries: 'записей'
};

const SGWT_SUPER_HEADER_I18N_IT: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'Gestisci profilo',
  changePassword: 'Cambia password',
  myServicesLink: 'I miei servizi',
  navigateAs: 'Naviga come',
  navigatingAs: 'Naviga come',
  signOut: 'Logout',
  userProfile: 'Your profile',
  searchPlaceholder: 'Cerca',
  columnName: 'Nome utente',
  columnCompany: 'Società',
  fist: 'First',
  previous: 'Previous',
  next: 'Next',
  last: 'Last',
  legendShowing: 'Showing',
  legendTo: 'to',
  legendOf: 'of',
  legendEntries: 'entries'
};

const SGWT_SUPER_HEADER_I18N_PT: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'Gerir a minha conta',
  changePassword: 'Alterar a palavra-passe',
  myServicesLink: 'Os meus serviços',
  navigateAs: 'Impersonalização',
  navigatingAs: 'Está a navegar como',
  signOut: 'Fim de sessão',
  userProfile: 'Your profile',
  searchPlaceholder: 'Pesquisar',
  columnName: 'Nome do cliente',
  columnCompany: 'Empresa do cliente',
  fist: 'First',
  previous: 'Previous',
  next: 'Next',
  last: 'Last',
  legendShowing: 'Showing',
  legendTo: 'to',
  legendOf: 'of',
  legendEntries: 'entries'
};

const SGWT_SUPER_HEADER_I18N_JA: ISgwtSuperHeaderI18NLanguage = {
  accountCenter: 'アカウントを管理する',
  changePassword: 'パスワードを変更する',
  myServicesLink: 'マイサービス',
  navigateAs: '他のユーザー としてナビゲート',
  navigatingAs: 'としてナビゲート中',
  signOut: 'ログアウト',
  userProfile: 'Your profile',
  searchPlaceholder: 'Quick search',
  columnName: 'クライアント名',
  columnCompany: 'クライアントカンパニー',
  fist: 'First',
  previous: 'Previous',
  next: 'Next',
  last: 'Last',
  legendShowing: 'Showing',
  legendTo: 'to',
  legendOf: 'of',
  legendEntries: 'entries'
};

export const SGWT_SUPER_HEADER_I18N: ISgwtSuperHeaderI18N = {
  en: SGWT_SUPER_HEADER_I18N_EN,
  fr: SGWT_SUPER_HEADER_I18N_FR,
  es: SGWT_SUPER_HEADER_I18N_ES,
  de: SGWT_SUPER_HEADER_I18N_DE,
  zh: SGWT_SUPER_HEADER_I18N_ZH,
  ru: SGWT_SUPER_HEADER_I18N_RU,
  it: SGWT_SUPER_HEADER_I18N_IT,
  pt: SGWT_SUPER_HEADER_I18N_PT,
  ja: SGWT_SUPER_HEADER_I18N_JA
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/sgwt-super-header.i18n.ts